<template>
  <Page page-type="result" />
</template>
<script>
import Page from '../components/CommonPage.vue';
export default {
  name: 'BusinessPurchaseReturnResult',
  components: {
    Page,
  },
  data() {
    return {};
  },
};
</script>
